<template>
	<div v-if="data" :id="data.id" class="modal">
		<div class="modal__content">
			<div class="p-5 text-center">
				<checkCircleIcon v-if="data.icon == 'check'" class="w-16 h-16 text-theme-9 mx-auto mt-3" />
				<xCircleIcon v-if="data.icon == 'x'" class="w-16 h-16 text-theme-6 mx-auto mt-3" />
				<div class="text-3xl mt-5">{{ data.title }}</div>
				<div class="text-gray-600 mt-2">{{ data.text }}</div>
			</div>
			<div v-if="data.buttons" class="px-5 pb-8 text-center">
				<button type="button" data-dismiss="modal" class="button w-24 border text-gray-700 mr-1">
					Cancelar
				</button>
				<button type="button" @click="confirm" class="button w-24 bg-theme-6 text-white">
					Quitar
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ["data"],
		methods:{
			confirm(){
				this.$emit("confirm");
			}
		}
	};

</script>
